import TrustBadges from "./TrustBadges";
import { stockAvailability } from "../utils/stockAvailability";

function ListingCard({ favoriteActionListingId, listing, onOpen, onToggleFavorite }) {
  const availability = stockAvailability(listing.inventoryCount);
  return (
    <article className="listing-card" onClick={() => onOpen?.(listing)}>
      {listing.image ? (
        <img src={listing.image} alt="" />
      ) : (
        <div className="listing-image-placeholder">Intet billede</div>
      )}
      <div className="listing-body">
        <div>
          <h3>{listing.title}</h3>
          <p>
            {listing.location} | {listing.category}
          </p>
          <p className="seller-line">
            {listing.seller} | {formatRating(listing)}
          </p>
          <TrustBadges
            compact
            completedSalesCount={listing.completedSalesCount}
            ratingAverage={listing.ratingAverage}
            ratingCount={listing.ratingCount}
            verified={listing.verified}
          />
        </div>
        <div className="listing-meta">
          <strong>{listing.price}</strong>
          {availability && <span className={`stock-label ${availability.level}`}>{availability.label}</span>}
        </div>
      </div>
      {onToggleFavorite && !listing.isOwner && (
        <button
          aria-label={listing.isFavorite ? "Fjern fra favoritter" : "Gem som favorit"}
          className={`favorite-button ${listing.isFavorite ? "active" : ""}`}
          disabled={favoriteActionListingId === listing.id}
          onClick={(event) => {
            event.stopPropagation();
            onToggleFavorite(listing);
          }}
          type="button"
        >
          {listing.isFavorite ? "♥" : "♡"}
        </button>
      )}
      {listing.hasMatchScore && <div className="match-badge">{listing.score}</div>}
    </article>
  );
}

function formatRating(listing) {
  if (!listing.ratingCount) {
    return "Ingen rating endnu";
  }

  return `${listing.ratingAverage.toFixed(1)} rating (${listing.ratingCount})`;
}

export default ListingCard;
